export default __webpack_public_path__ + "static/B28-36f4f2292ce0756ebc47641b22182575.png";